<template>
  <div class="home">
    <div id="companies-table" :style="'grid-template-columns:' + this.months.map(m => 'auto').join(' ') + ' auto auto'" class="data-table">
      <div class="header">
        <div>Company Name</div>
        <div>LTV</div>
        <div
          v-for="month in months"
          v-bind:key="month"
        >
          {{month}}
        </div>
      </div>
      <div
        v-for="company in companies"
        v-bind:key="company.id"
        class="row"
      >
        <div class="cell id">{{ company.name }}</div>
        <div class="cell">
          {{ Math.round(company.ltv || 0)}}
        </div>
        <div
          class="cell"
          v-for="month in months"
          v-bind:key="month"
        >
          {{Math.round((company.totals || {})[month] || 0)}}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
#companies-table {
  .row.disabled .cell {
    color: #aaa;
  }
  .cell input {
    padding: 10px;
  }
  .inputcell {
    padding: 0;
  }
}
</style>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import api from "../services/api";
import dayjs from 'dayjs';

export default {
  name: "home",
  data: function() {
    return {
      companies: [],
      months: [
      ]
    };
  },
  filters: {
    percent: (dec) => {
      if (dec <= 1) {
          return dec * 100 + "%";
      }
      return 'Please enter number less than or equal to 1'
    }
  },
  async created() {
    const startYear = 21;
    const startMonth = 7;
    const endYear = parseInt(dayjs().format('YY'));
    const endMonth = parseInt(dayjs().format('MM'));
    const months = [];
    for (let i = startYear; i <= endYear; i++) {
      for (let j = (i === startYear ? startMonth : 1) ; j <= (i === endYear ? endMonth : 12); j++) {
        months.push(i + '-' + (j < 10 ? '0' : '') + j);
      }
    }
    this.months = months;
    this.companies = (await api.getCompanies()).sort(
      (v1, v2) => {
        const coef1 = v1.licenseType ? 1 : 2;
        const coef2 = v2.licenseType ? 1 : 2;
        return v1.createdAt.seconds * coef1 - v2.createdAt.seconds * coef2;
      }
    ).filter(c => c.licenseType === 'full');

    for(let i = 0; i < this.companies.length; i++) {
      const company = this.companies[i];
      const reports = await api.getCompanyReports(company.id);
      company.totals = {};
      company.ltv = 0;
      Object.values(reports).forEach(report => {
        const month = report.month.substr(2,5);
        const rev = report.total + (report.clientsTotal || 0);
        company.totals[month] = rev;
        company.ltv += rev;
      });
      this.$forceUpdate();
    }
  }
};
</script>
